export const Divider = {
  baseStyle: {
    borderColor: 'gray.200',
  },
};
